<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? '编辑' : '新增'"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item name="deptId" label="区域" :rules="[{ required: true, message: '请选择' }]" >
        <CustomerAreaCascader
          appId="cos_fbu"
          deptInfoId="815717"
          v-model:value="editForm.deptId"
          v-model:label="editForm.deptName"
        />
      </a-form-item>
      <a-form-item name="deptManager" label="区域负责人" :rules="[{ required: true, message: '请选择' }]" >
        <user-select v-model:value="editForm.deptManager" allowClear mode="multiple" />
      </a-form-item>
      <a-form-item name="deptScope" label="区域员工" :rules="[{ required: true, message: '请选择' }]">
        <user-select v-model:value="editForm.deptScope" allowClear mode="multiple" />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref, h } from 'vue'
import type { FormInstance } from 'ant-design-vue'
import { DcMessage } from '@dc-platform/dc-components'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import {
  createRegionSetting,
  updateRegionSetting
} from '@/api/gucangSales/regionSetting'
export default { name: 'editModal' }
</script>
<script setup lang="ts">
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref({})
const emit = defineEmits(['success'])
const toggle = (row?: any) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const p = { ...editForm.value }
    if (p.deptName) {
      p.deptName = p.deptName.split('/').pop()
    }
    try {
      if (editForm.value.id) {
        await updateRegionSetting(p)
      } else {
        await createRegionSetting(p)
      }
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? '编辑成功' : '新增成功')
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss" scoped>
.title-box {
  display: flex;
  align-items: center;
  .title-span {
    font-weight: 500;
    color: red;
    font-size: 14px;
  }
}
</style>
